import React, { useState, useEffect, useRef } from "react";
import {
  FiUsers,
  FiTrendingUp,
  FiAward,
  FiZap,
  FiCheckCircle,
  FiCheckSquare,
  FiClock,
  FiShield,
  FiTarget,
  FiBarChart,
  FiUserCheck,
  FiGlobe,
  FiStar,
  FiBriefcase,
  FiHeart
} from "react-icons/fi";
import { useNavigate } from 'react-router-dom';


const HRCopilotHeroSection = () => {
  const [statsVisible, setStatsVisible] = useState(false);
  const statsContainerRef = useRef(null);
  const navigate = useNavigate();
  const handleGetStarted = () => navigate('/access-recruit');

  useEffect(() => {
    const timer = setTimeout(() => setStatsVisible(true), 1000);
    return () => clearTimeout(timer);
  }, []);

        
  // Duplicate stats for seamless infinite loop
  const statsData = [
    { value: "25K+", label: "Approvals Processed", icon: <FiCheckSquare /> },
    { value: "90%", label: "Faster Approvals", icon: <FiTrendingUp /> },
    { value: "99.9%", label: "Compliance Rate", icon: <FiCheckCircle /> },
    { value: "Real-Time", label: "Notifications", icon: <FiClock /> }
  ];

  // Duplicate the stats for seamless infinite scrolling
  const stats = [...statsData, ...statsData, ...statsData];


  const benefits = [
    { icon: <FiBriefcase />, text: "Talent Acquisition Suite", color: "#c62828" },
    { icon: <FiBarChart />, text: "Advanced Workforce Analytics", color: "#c62828" },
    { icon: <FiTarget />, text: "Performance Optimization", color: "#c62828" },
    { icon: <FiAward />, text: "Employee Experience Platform", color: "#c62828" },
    { icon: <FiGlobe />, text: "Global Compliance Management", color: "#c62828" },
    { icon: <FiHeart />, text: "Employee Wellbeing Tools", color: "#c62828" },
  ];

  return (
    <section className="bst-hero-section">
      {/* Animated Background Elements */}
      <div className="bst-bg-gradient-overlay"></div>
      <div className="bst-grid-pattern"></div>

      <div className="bst-hero-container">
        {/* Main Content - Centered */}
        <div className="bst-hero-content">
          {/* Badge */}
          <div className="bst-badge">
            <FiAward className="bst-badge-icon" />
            <span>ENTERPRISE-GRADE HR PLATFORM</span>
          </div>

          {/* Main Title */}
          <h1 className="bst-hero-titlee">
            <span className="bst-title-primary">Revolutionizing<span className="bst-title-secondary"> Experience</span>
</span>
            <span className="bst-title-accent">With Intelligent HR Technology</span>
          </h1>

          {/* Subtitle */}
          <p className="bst-hero-subtitle">
            Humanex delivers comprehensive HR solutions that transform how organizations manage talent, 
            optimize workforce performance, and elevate employee experience through cutting-edge AI and automation.
          </p>

          {/* Call-to-Action Buttons */}
          <div className="bst-cta-buttons">
            <button className="bst-btn bst-btn-primary" onClick={handleGetStarted}>
              <span>Transform Your HR</span>
              <FiZap className="bst-btn-icon" />
            </button>
            <button className="bst-btn bst-btn-secondary" onClick={handleGetStarted}>
              <span>Request Enterprise Demo</span>
            </button>
          </div>

          {/* Trust Indicators */}
          <div className="bst-trust-row">
            <div className="bst-trust-item">
              <FiShield className="bst-trust-icon" />
              <span>GDPR & SOC2 Compliant</span>
            </div>
            <div className="bst-trust-item">
              <FiClock className="bst-trust-icon" />
              <span>Enterprise Integration</span>
            </div>
            <div className="bst-trust-item">
              <FiCheckCircle className="bst-trust-icon" />
              <span>24/7 Premium Support</span>
            </div>
          </div>
        </div>

        {/* Hero Image - Centered */}
        <div className="bst-hero-image-wrapper">
          <div className="bst-image-glow"></div>
          <div className="bst-image-container">
            <img
              src="/images/abov2.png"
              alt="Humanex HR Management Dashboard"
              className="bst-hero-image"
            />
            
            {/* Floating Stats Cards */}
            <div className="bst-float-card bst-card-1">
              <div className="bst-card-icon bst-icon-primary">
                <FiTrendingUp />
              </div>
              <div className="bst-card-content">
                <div className="bst-card-value">47%</div>
                <div className="bst-card-label">Reduced Turnover</div>
              </div>
            </div>

            <div className="bst-float-card bst-card-2">
              <div className="bst-card-icon bst-icon-success">
                <FiBarChart />
              </div>
              <div className="bst-card-content">
                <div className="bst-card-value">3.2x</div>
                <div className="bst-card-label">ROI Increase</div>
              </div>
            </div>

            <div className="bst-float-card bst-card-3">
              <div className="bst-card-icon bst-icon-warning">
                <FiAward />
              </div>
              <div className="bst-card-content">
                <div className="bst-card-value">4.8/5</div>
                <div className="bst-card-label">Gartner Rating</div>
              </div>
            </div>
          </div>
        </div>
   {/* STATS SECTION - Continuous Slider */}
      <div className="bst-stats-wrapper">
        <div className="bst-stats-slider-container">
          <div 
            className={`bst-stats-slider-track ${statsVisible ? 'bst-stats-slider-running' : ''}`}
            ref={statsContainerRef}
          >
            {stats.map((stat, index) => (
              <div
                key={index}
                className="bst-stat-card-slider"
                style={{ 
                  // Calculate position for seamless loop
                  '--item-index': index % statsData.length
                }}
              >
                <div className="bst-stat-icon">{stat.icon}</div>
                <div className="bst-stat-value">{stat.value}</div>
                <div className="bst-stat-label">{stat.label}</div>
              </div>
            ))}
          </div>
          
          {/* Gradient overlays for fade effect */}
          <div className="bst-slider-fade bst-slider-fade-left"></div>
          <div className="bst-slider-fade bst-slider-fade-right"></div>
        </div>
      </div>


        {/* Benefits Grid */}
        {/* <div className="bst-benefits-section">
          <h3 className="bst-benefits-title">Comprehensive HR Solutions</h3>
          <div className="bst-benefits-grid">
            {benefits.map((benefit, index) => (
              <div 
                key={index} 
                className="bst-benefit-card"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="bst-benefit-icon" style={{ color: benefit.color }}>
                  {benefit.icon}
                </div>
                <span className="bst-benefit-text">{benefit.text}</span>
              </div>
            ))}
          </div>
        </div> */}
      </div>

      <style jsx>{`
        /* Import Raleway Font */
        @import url('https://fonts.googleapis.com/css2?family=Raleway:wght@300;400;500;600;700;800;900&display=swap');

        /* ===========================
           MAIN HERO SECTION
        =========================== */
        .bst-hero-section {
          position: relative;
          width: 100%;
          min-height: 100vh;
          background: #ffffffff;
          overflow: hidden;
          padding: 80px 20px 60px;
          font-family: 'Raleway', sans-serif;
        }

        /* ===========================
           BACKGROUND ANIMATIONS
        =========================== */
        .bst-bg-gradient-overlay {
          position: absolute;
          inset: 0;
          background: radial-gradient(circle at 50% 50%, rgba(198, 40, 40, 0.03) 0%, transparent 70%);
          pointer-events: none;
        }

        .bst-grid-pattern {
          position: absolute;
          inset: 0;
          background-image: 
            linear-gradient(rgba(198, 40, 40, 0.02) 1px, transparent 1px),
            linear-gradient(90deg, rgba(198, 40, 40, 0.02) 1px, transparent 1px);
          background-size: 60px 60px;
          opacity: 0.6;
        }

        /* ===========================
           CONTAINER
        =========================== */
        .bst-hero-container {
          position: relative;
          max-width: 1400px;
          margin: 0 auto;
          z-index: 1;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 60px;
          margin-top: 50px;
        }

        /* ===========================
           HERO CONTENT (Centered)
        =========================== */
        .bst-hero-content {
          text-align: center;
          max-width: 1400px;
          animation: bstFadeInUp 1s ease-out;
        }

        @keyframes bstFadeInUp {
          from {
            opacity: 0;
            transform: translateY(40px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        /* Badge */
        .bst-badge {
          display: inline-flex;
          align-items: center;
          gap: 10px;
          background: linear-gradient(135deg, rgba(198, 40, 40, 0.1), rgba(198, 40, 40, 0.05));
          padding: 12px 24px;
          border-radius: 50px;
          border: 1.5px solid rgba(198, 40, 40, 0.2);
          font-size: 12px;
          font-weight: 700;
          letter-spacing: 1.8px;
          color: #c62828;
          margin-bottom: 30px;
          animation: bstBadgePulse 2.5s ease infinite;
        }

        @keyframes bstBadgePulse {
          0%, 100% { 
            box-shadow: 0 0 0 0 rgba(198, 40, 40, 0.4);
            transform: scale(1);
          }
          50% { 
            box-shadow: 0 0 0 10px rgba(198, 40, 40, 0);
            transform: scale(1.05);
          }
        }

        .bst-badge-icon {
          font-size: 16px;
          animation: bstRotateSpin 3s linear infinite;
        }

        @keyframes bstRotateSpin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }

        /* Main Title */
        .bst-hero-titlee {
          font-size: 50px;
          line-height: 1.4;
          margin-bottom: 24px;
          font-weight: 900;
          font-family: "Raleway", sans-serif;
          display: flex;
          flex-direction: column;
          gap: 8px;
          animation: bstTitleReveal 1.2s ease-out;
        }

        @keyframes bstTitleReveal {
          from {
            opacity: 0;
            transform: translateY(30px);
            filter: blur(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
            filter: blur(0);
          }
        }

        .bst-title-primary {
          color: #1e2330;
          font-weight: 900;
        }

        .bst-title-secondary {
          color: #c62828;
          font-weight: 900;
        }

        .bst-title-accent {
          color: #1e2330;
          font-weight: 900;
          font-size: 52px;
          font-family: "Raleway", sans-serif;
        }

        /* Subtitle */
        .bst-hero-subtitle {
          font-size: 18px;
          line-height: 1.8;
          color: #6b7280;
          margin-bottom: 40px;
          max-width: 700px;
          margin-left: auto;
          margin-right: auto;
          animation: bstFadeIn 1.5s ease-out;
        }

        @keyframes bstFadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        /* ===========================
           CTA BUTTONS
        =========================== */
        .bst-cta-buttons {
          display: flex;
          gap: 20px;
          justify-content: center;
          margin-bottom: 35px;
          flex-wrap: wrap;
        }

        .bst-btn {
          padding: 18px 40px;
          border: none;
          border-radius: 50px;
          font-size: 15px;
          font-weight: 700;
          letter-spacing: 0.5px;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          gap: 10px;
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          position: relative;
          overflow: hidden;
          font-family: 'Raleway', sans-serif;
        }

        .bst-btn::before {
          content: '';
          position: absolute;
          top: 50%;
          left: 50%;
          width: 0;
          height: 0;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.3);
          transform: translate(-50%, -50%);
          transition: width 0.6s ease, height 0.6s ease;
        }

        .bst-btn:hover::before {
          width: 350px;
          height: 350px;
        }

        .bst-btn-primary {
          background: linear-gradient(135deg, #c62828, #d32f2f);
          color: #ffffff;
          box-shadow: 0 6px 20px rgba(198, 40, 40, 0.3);
        }

        .bst-btn-primary:hover {
          transform: translateY(-5px);
          box-shadow: 0 12px 35px rgba(198, 40, 40, 0.45);
        }

        .bst-btn-secondary {
          background: #ffffff;
          color: #1e2330;
          border: 2px solid #e5e7eb;
          box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
        }

        .bst-btn-secondary:hover {
          transform: translateY(-5px);
          box-shadow: 0 12px 35px rgba(0, 0, 0, 0.15);
          border-color: #c62828;
          color: #c62828;
        }

        .bst-btn-icon {
          font-size: 18px;
          position: relative;
          z-index: 1;
        }

        .bst-btn span {
          position: relative;
          z-index: 1;
        }

        /* ===========================
           TRUST INDICATORS
        =========================== */
        .bst-trust-row {
          display: flex;
          gap: 35px;
          justify-content: center;
          flex-wrap: wrap;
          animation: bstSlideUp 1.8s ease-out;
        }

        @keyframes bstSlideUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .bst-trust-item {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 14px;
          color: #6b7280;
          font-weight: 600;
        }

        .bst-trust-icon {
          color: #c62828;
          font-size: 20px;
        }

        /* ===========================
           HERO IMAGE (Centered)
        =========================== */
        .bst-hero-image-wrapper {
          position: relative;
          width: 100%;
          max-width: 1000px;
          animation: bstZoomIn 1.3s ease-out;
        }

        @keyframes bstZoomIn {
          from {
            opacity: 0;
            transform: scale(0.9);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }

        .bst-image-glow {
          position: absolute;
          inset: -40px;
          background: radial-gradient(circle, rgba(198, 40, 40, 0.2) 0%, transparent 70%);
          filter: blur(60px);
          z-index: -1;
          animation: bstGlowPulse 4s ease-in-out infinite;
        }

        @keyframes bstGlowPulse {
          0%, 100% { opacity: 0.6; }
          50% { opacity: 1; }
        }

        .bst-image-container {
          position: relative;
          border-radius: 24px;
          overflow: visible;
        //   box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15);
        }

        .bst-hero-image {
          width: 100%;
          height: auto;
          display: block;
          border-radius: 24px;
          animation: bstFloatImage 6s ease-in-out infinite;
        }

        @keyframes bstFloatImage {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
        }

        /* ===========================
           FLOATING CARDS
        =========================== */
        .bst-float-card {
          position: absolute;
          background: #ffffff;
          padding: 20px;
          border-radius: 16px;
          box-shadow: 0 12px 45px rgba(0, 0, 0, 0.12);
          display: flex;
          align-items: center;
          gap: 15px;
          backdrop-filter: blur(10px);
          border: 1px solid rgba(229, 231, 235, 0.8);
          animation: bstCardFloat 5s ease-in-out infinite;
        }

        .bst-card-1 {
          top: 8%;
          left: -8%;
          animation-delay: 0s;
        }

        .bst-card-2 {
          top: 45%;
          right: -10%;
          animation-delay: 1.5s;
        }

        .bst-card-3 {
          bottom: 12%;
          left: -6%;
          animation-delay: 3s;
        }

        @keyframes bstCardFloat {
          0%, 100% { 
            transform: translateY(0px) rotate(0deg); 
          }
          50% { 
            transform: translateY(-18px) rotate(2deg); 
          }
        }

        .bst-card-icon {
          width: 55px;
          height: 55px;
          border-radius: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #ffffff;
          font-size: 24px;
          flex-shrink: 0;
        }

        .bst-icon-primary {
          background: linear-gradient(135deg, #c62828, #d32f2f);
        }

        .bst-icon-success {
          background: linear-gradient(135deg, #c62828, #ef5350);
        }

        .bst-icon-warning {
          background: linear-gradient(135deg, #b71c1c, #c62828);
        }

        .bst-card-content {
          display: flex;
          flex-direction: column;
        }

        .bst-card-value {
          font-size: 26px;
          font-weight: 900;
          color: #1e2330;
          line-height: 1;
          margin-bottom: 4px;
        }

        .bst-card-label {
          font-size: 13px;
          color: #6b7280;
          font-weight: 600;
        }
/* ===========================
           STATS SLIDER SECTION - CONTINUOUS RUNNING
           (Updated: No box shadow, Proper card size)
        =========================== */
        .bst-stats-wrapper {
          display: flex;
          justify-content: center;
          margin: 60px 0 40px;
          width: 100%;
          padding: 0 20px;
          overflow: hidden;
          position: relative;
          background: transparent;
        }
        
        .bst-stats-slider-container {
          position: relative;
          width: 100%;
          max-width: 1440px;
          margin: 0 auto;
          overflow: hidden;
          background: transparent;
          padding: 30px 0;
          box-shadow: none; /* Removed box shadow */
        }
        
        .bst-stats-slider-track {
          display: flex;
          gap: 30px; /* Reduced gap */
          width: max-content;
          animation: bstSliderScroll 40s linear infinite;
          animation-play-state: paused;
          padding: 0 20px;
        }
        
        .bst-stats-slider-running {
          animation-play-state: running;
        }
        
        @keyframes bstSliderScroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(calc(-33.33% - 10px)); /* Adjusted for reduced gap */
          }
        }
        
        .bst-stat-card-slider {
          flex: 0 0 auto;
          width: 290px; /* Reduced width for proper size */
          height: 200px; /* Fixed height */
          background: white;
          border-radius: 16px;
          padding: 25px 20px; /* Reduced padding */
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          border: 1px solid rgba(0, 0, 0, 0.08);
          transition: all 0.3s ease;
          position: relative;
          overflow: hidden;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05); /* Minimal shadow for depth */
        }
        
        .bst-stat-card-slider:hover {
          transform: translateY(-5px);
          border-color: rgba(198, 40, 40, 0.2);
          box-shadow: 0 8px 20px rgba(198, 40, 40, 0.1);
        }
        
        .bst-stat-icon {
          font-size: 32px; /* Reduced icon size */
          color: #c62828;
          margin-bottom: 12px;
          animation: bstIconBounce 2s ease-in-out infinite;
        }

        @keyframes bstIconBounce {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-8px); }
        }
        
        .bst-stat-value {
          font-size: 32px; /* Reduced font size */
          font-weight: 800;
          background: linear-gradient(135deg, #c62828, #ff5252);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          margin-bottom: 8px;
          font-family: 'Poppins', sans-serif;
          text-align: center;
          line-height: 1.2;
        }
        
        .bst-stat-label {
          font-size: 14px; /* Reduced font size */
          color: #666;
          font-weight: 600;
          text-align: center;
          line-height: 1.3;
        }
        
        /* Gradient fade effects on edges */
        .bst-slider-fade {
          position: absolute;
          top: 0;
          bottom: 0;
          width: 100px;
          pointer-events: none;
          z-index: 2;
        }
        
        .bst-slider-fade-left {
          left: 0;
          background: linear-gradient(90deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%);
        }
        
        .bst-slider-fade-right {
          right: 0;
          background: linear-gradient(270deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%);
        }

        /* ===========================
           BENEFITS SECTION
        =========================== */
        .bst-benefits-section {
          width: 100%;
          max-width: 1100px;
        }

        .bst-benefits-title {
          font-size: 32px;
          font-weight: 700;
          text-align: center;
          color: #1e2330;
          margin-bottom: 35px;
          font-family: 'Raleway', sans-serif;
        }

        .bst-benefits-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 20px;
        }

        .bst-benefit-card {
          display: flex;
          align-items: center;
          gap: 15px;
          padding: 20px 25px;
          background: #ffffff;
          border-radius: 16px;
          border: 1px solid #e5e7eb;
          opacity: 0;
          transform: translateX(-30px);
          animation: bstBenefitSlide 0.8s ease-out forwards;
          transition: all 0.3s ease;
        }

        @keyframes bstBenefitSlide {
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        .bst-benefit-card:hover {
          transform: translateY(-6px);
          box-shadow: 0 12px 30px rgba(198, 40, 40, 0.15);
          border-color: rgba(198, 40, 40, 0.3);
        }

        .bst-benefit-icon {
          font-size: 28px;
          flex-shrink: 0;
          animation: bstIconPulse 2.5s ease-in-out infinite;
        }

        @keyframes bstIconPulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.15); }
        }

        .bst-benefit-text {
          font-size: 15px;
          font-weight: 600;
          color: #1e2330;
        }

        /* ===========================
           RESPONSIVE DESIGN
        =========================== */
        @media screen and (max-width: 1200px) {
          .bst-hero-title {
            font-size: 56px;
          }

          .bst-title-accent {
            font-size: 46px;
          }

          .bst-float-card {
            display: none;
          }
        }

        @media screen and (max-width: 992px) {
          .bst-hero-section {
            padding: 60px 20px 50px;
          }

          .bst-hero-title {
            font-size: 48px;
          }

          .bst-title-accent {
            font-size: 40px;
          }

          .bst-hero-subtitle {
            font-size: 16px;
          }

          .bst-stats-section {
            grid-template-columns: repeat(2, 1fr);
            padding: 25px;
          }

          .bst-benefits-grid {
            grid-template-columns: repeat(2, 1fr);
          }

          .bst-cta-buttons {
            flex-direction: column;
            width: 100%;
            max-width: 400px;
            margin-left: auto;
            margin-right: auto;
          }

          .bst-btn {
            width: 100%;
            justify-content: center;
          }
        }

        @media screen and (max-width: 768px) {
          .bst-hero-title {
            font-size: 40px;
          }

          .bst-title-accent {
            font-size: 34px;
          }

          .bst-stats-section {
            grid-template-columns: 1fr;
            gap: 15px;
          }

          .bst-benefits-grid {
            grid-template-columns: 1fr;
          }

          .bst-trust-row {
            flex-direction: column;
            gap: 20px;
          }
        }

        @media screen and (max-width: 576px) {
          .bst-hero-title {
            font-size: 34px;
          }

          .bst-title-accent {
            font-size: 28px;
          }

          .bst-hero-subtitle {
            font-size: 15px;
          }

          .bst-badge {
            font-size: 10px;
            padding: 10px 20px;
          }
        }
      `}</style>
    </section>
  );
};

export default HRCopilotHeroSection;